import type { ChatReference, ChatReferenceCard } from '@till-erp/chat/values';
import { onChatMemoryClear } from './chat-memory.ts';
export type { ChatReference, ChatReferenceCard };
/** Only the # fragment touching the caret is replaced; never text elsewhere or a selected range. */
export function chatReferenceFragment(body: string, start: number, end = start): { start: number; end: number; query: string } | null {
  if (start !== end || start < 0 || start > body.length) return null;
  const before = body.slice(0, start);
  const match = /(?:^|\s)#([^#\n\r]*)$/u.exec(before);
  if (!match) return null;
  const at = before.lastIndexOf('#');
  return { start: at, end: start, query: match[1]! };
}
/** No sensitive labels are persisted in the shared draft. */
export function addChatReference(current: readonly ChatReference[], next: ChatReference): ChatReference[] {
  return current.some((r) => r.entityType === next.entityType && r.entityId === next.entityId) ? [...current] : [...current, { entityType: next.entityType, entityId: next.entityId }];
}
let epoch = 0;
const listeners = new Set<() => void>();
export const chatReferenceEpoch = () => epoch;
export const subscribeChatReferenceEpoch = (listener: () => void) => {
  if (!listeners.size && typeof window !== 'undefined') window.addEventListener('focus', resetChatReferenceViews);
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
    if (!listeners.size && typeof window !== 'undefined') window.removeEventListener('focus', resetChatReferenceViews);
  };
};
/** A permission/membership/reconnect boundary invalidates pending responses as well as previously loaded cards. */
export function resetChatReferenceViews() { epoch++; for (const listener of listeners) listener(); }

onChatMemoryClear(() => resetChatReferenceViews());
